import { ClientOSErrorCode } from './ErrorCodes';

export class ClientOSError extends Error {
  readonly errorCode: ClientOSErrorCode;
  readonly originalError: Error | unknown;

  constructor(
    message: string,
    errorCode: ClientOSErrorCode,
    originalError: Error | unknown
  ) {
    super(message);
    this.name = 'ClientOSError';
    this.errorCode = errorCode;
    this.originalError = originalError;

    // Write to window BEFORE propagating so browser-web-mfe-composer/index.ejs
    // can call window.updateErrorCode(errorCode) immediately.
    if (typeof window !== 'undefined') {
      window.updateErrorCode?.(errorCode);
    }
  }
}
